module.exports = __webpack_public_path__ + "static/media/revenue-operations-feature-tile-icon-01.2bf49f1e.svg";